import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import EmbedHikeCard from './EmbedHikeCard';

/**
 * Embed page for iframe integration.
 *
 * URL params:
 * - hikeId: The ID of the hike to display
 * - theme: 'light' or 'dark' (default: light)
 *
 * Example: /embed/hike?hikeId=42&theme=dark
 */
export default function EmbedPage() {
  const [searchParams] = useSearchParams();

  const hikeId = searchParams.get('hikeId');
  const theme = searchParams.get('theme') || 'light';

  // Remove default body margin/padding for embed and make it fill iframe
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100%';

    // Also set the root element
    const root = document.getElementById('root');
    if (root) {
      root.style.height = '100%';
    }

    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
      if (root) {
        root.style.height = '';
      }
    };
  }, []);

  if (!hikeId) {
    return (
      <div className="p-4 text-red-500 text-sm">
        Errore: hikeId mancante
      </div>
    );
  }

  return (
    <div
      className={theme === 'dark' ? 'bg-gray-900' : 'bg-transparent'}
      style={{
        margin: 0,
        padding: '8px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        height: '100%',
        width: '100%'
      }}
    >
      <EmbedHikeCard hikeId={parseInt(hikeId, 10)} theme={theme} />
    </div>
  );
}
